import React from 'react'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

const colorMap = {
  green: '#10b981',  // Emerald-500
  red: '#ef4444', // Red-500
  grey: '#9ca3af',
}

type BooleanIconColor = keyof typeof colorMap
export const BooleanIcon: React.FC<{
  value?: boolean,
  trueColor?: BooleanIconColor,
  falseColor?: BooleanIconColor
}> = ({
  value,
  trueColor = 'green',
  falseColor = 'red',
}) => {
  return value ?
    <CheckCircleOutlined style={{ color: colorMap[trueColor] }} /> :
    <CloseCircleOutlined style={{ color: colorMap[falseColor] }} />
}

export const DangerBooleanIcon: React.FC<{
  value?: boolean,
}> = ({
  value,
}) => {
  return <BooleanIcon value={value} trueColor="red" falseColor="grey" />
}